import './QuillWrapper.scss';

const QuillWrapper = ({ children }) => {
  return <div className="QuillWrapper">{children}</div>;
};

export default QuillWrapper;
